/* tslint:disable */
import { Langue } from './langue';
import { DefaultEquipment } from './default-equipment';
import { Units } from './units';

/**
 */
export class Profile {
    Langue?: Langue;
    DefaultEquipment?: DefaultEquipment;
    UnitsUsers?: Units;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/profile.ts